import { render } from "./RawDataAccessTable.vue?vue&type=template&id=63f39936&scoped=true"
import script from "./RawDataAccessTable.vue?vue&type=script&lang=js"
export * from "./RawDataAccessTable.vue?vue&type=script&lang=js"

import "./RawDataAccessTable.vue?vue&type=style&index=0&id=63f39936&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f39936"]])

export default __exports__